module.exports = __webpack_public_path__ + "static/media/sunarch_5.ca7fe3e8.gif";